export default __webpack_public_path__ + "static/media/business-advisory-header.31420fb0.svg";